function removeFigure (val) {
  if (!val) {
    return val
  }
  val = val.toString()
  val = val.replace(/,/g, '')
  return parseInt(val)
}

export default removeFigure



// WEBPACK FOOTER //
// ./src/misc/removeFigure.js